import { formatDate } from "hooks";
import React from "react";

const DateWidget = ({ createDate, updateDate }) => {
  return (
    <div className="grid">
      <span className="text-[14px]">Create: {formatDate(createDate)}</span>
      {updateDate && (
        <span className="text-[14px]">Update: {formatDate(updateDate)}</span>
      )}
    </div>
  );
};

export default DateWidget;
